import { useSelector } from 'react-redux';

import type { RootState } from '../../../../../../store';

export default function useTreatmentPlanV3EducationPageState() {
  const educationPage = useSelector((state: RootState) => state.treatmentPlanV3.educationPage);
  const educationInfo = educationPage?.education_info ?? null;
  const notAttendingSchool = educationPage?.not_attending_school ?? false;
  const hasLoaded = educationPage !== null;
  const hasLoadError = useSelector(
    (state: RootState) => state.treatmentPlanV3.educationPageError != null,
  );
  const educationPageLoading = useSelector(
    (state: RootState) => state.treatmentPlanV3.educationPageLoading,
  );
  // Idle (fetch not started) and in-flight both count as loading so the form stays gated.
  const isLoading = educationPageLoading || (!hasLoaded && !hasLoadError);
  const isUpdating = useSelector(
    (state: RootState) => state.treatmentPlanV3.updateEducationInfoLoading,
  );
  const isSaving = useSelector(
    (state: RootState) =>
      state.treatmentPlanV3.updateEducationInfoLoading ||
      state.treatmentPlanV3.setNotAttendingSchoolLoading,
  );

  return {
    educationInfo,
    notAttendingSchool,
    isLoading,
    hasLoaded,
    hasLoadError,
    isSaving,
    isUpdating,
  };
}
